import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Img_1 from './../images/slider/90890557952.jpg';
import Img_2 from './../images/slider/27459517111.jpg';

const HomeSliderBanner = () => {
    var Banner = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: false,
      };
  return (
   <>
    <section>
        <div id="demo" className="carousel slide cate-sli caro-home" data-ride="carousel">
            <div className="container">
                <div className="row">
                    <div className="inn">
                        <div className="home-banner-slider">
                        <Slider {...Banner}>
                                <img src={Img_1} alt="Los Angeles" width="1100" height="500"
                                    loading="lazy"/>
                                <img src={Img_2} alt="Los Angeles" width="1100" height="500"
                                    loading="lazy"/>
                                    </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
   </>
  )
}

export default HomeSliderBanner